<main class="mat-body" *ngIf="selectedProduct">
    <div class="container">
        <div class="row">
            <div class="col-12 pt-3">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'operative.sign'|translate"></h1>
                    </div>
                    <div class="col-auto">
                        {{ 'operative.contract-code'|translate }}
                        <strong class="text-blue">{{ contract.bankCode }}</strong>
                    </div>
                </div>
                <hr class="mt-1 mb-3" />

                <div class="row">
                    <div class="col-12 col-sm-5">
                        <label>{{ 'product.order'|translate }}</label>
                        <h2 class="mat-title text-blue font-weight-bold mb-0" [ngSwitch]="selectedProduct.order.type">
                            <ng-container *ngSwitchCase="OrderType.EXTERNAL_TRANSFER"
                                >{{ 'form.order-type.external-transfer'|translate }}</ng-container
                            >
                            <ng-container *ngSwitchCase="OrderType.INTERNAL_TRANSFER"
                                >{{ 'form.order-type.internal-transfer'|translate }}</ng-container
                            >
                            <ng-container *ngSwitchCase="OrderType.REFUND">{{ 'form.order-type.refund'|translate }}</ng-container>
                            <ng-container *ngSwitchCase="OrderType.REFUND_PERIOD"
                                >{{ 'form.order-type.refund-period'|translate }}</ng-container
                            >
                            <ng-container *ngSwitchCase="OrderType.SUBSCRIPTION"
                                >{{ 'form.order-type.subscription'|translate }}</ng-container
                            >
                            <ng-container *ngSwitchCase="OrderType.SUBSCRIPTION_PERIOD"
                                >{{ 'form.order-type.subscription-period'|translate }}</ng-container
                            >
                        </h2>
                    </div>
                    <div class="col-12 col-sm-7 mt-3 mt-sm-0">
                        <label>{{ 'product.name'|translate }}</label>
                        <h2 class="mat-title text-blue font-weight-bold mb-0">{{ selectedProduct.name }}</h2>
                    </div>
                </div>
                <hr class="mt-3 mb-5" />

                <form #formOperateSign="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
                    <thr-operate-form-sign
                        [signedBy]="signedBy"
                        [allowDigital]="allowDigital"
                        [allowHandwritten]="allowHandwritten"
                        [participants]="participants"
                    ></thr-operate-form-sign>

                    <div class="row justify-content-end">
                        <div class="col-12 col-sm-6 col-md-4">
                            <button
                                type="submit"
                                class="full-width mat-elevation-z0"
                                mat-raised-button
                                color="blue"
                                [disabled]="!formOperateSign.valid"
                            >
                                {{ 'general.sign'|translate }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</main>
